<template>
  <section>
    <v-card>
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          <v-row align="center">
            <v-col class="grow">
              Mock materials
            </v-col>
            <v-col class="shrink">
              <v-btn small @click="toggleCreateItemDialog">create new</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>
    </v-card>

    <v-container fluid>
<!--      <v-row>-->
<!--        <v-col cols="12" md="6">-->
<!--          <v-card>-->
<!--            <v-toolbar flat outlined @click="upload_item_dialog = !upload_item_dialog">-->
<!--              Upload file-->
<!--            </v-toolbar>-->
<!--            <v-card-text v-if="upload_item_dialog">-->
<!--              <file-uploader label="File (docx, pdf)" accept="*"-->
<!--                             :upload_url="`api/mocks/${$route.params.mock_id}/materials/upload`"-->
<!--                             @uploaded="upload_item_dialog = !upload_item_dialog, loadMaterials()"-->
<!--              ></file-uploader>-->
<!--            </v-card-text>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--        <v-col cols="12" md="6">-->
<!--          -->
<!--        </v-col>-->
<!--      </v-row>-->
    </v-container>

    <v-container fluid>
      <v-data-iterator
          :items="materials"
          item-key="id"
          disable-pagination
          disable-filtering
      >
        <template v-slot:default="{ items }">
          <v-row>
            <v-col cols="12" md="6" v-for="item in items" :key="item.id">
              <v-card>
                <v-list-item>
                  <v-list-item-avatar tile size="50">
                    <img :src="`/img/google/${materialIcon(item)}.png`" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>

                  <v-btn small color="primary" @click="openSelectedItemDialog(item)">
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                  <v-btn small color="success" target="_blank"
                         :disabled="!item.google_view_link"
                         :href="item.google_view_link">
                    <v-icon>mdi-link</v-icon>
                  </v-btn>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>

    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="500px">
      <v-card v-if="selected_item">
        <v-toolbar dense dark color="primary">
          {{ selected_item.title }}
          <v-spacer/>
          <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-text-field label="Title" v-model="selected_item.title" outlined></v-text-field>

          <v-switch label="Student can view" v-model="selected_item.student_can_view"></v-switch>
        </v-card-text>
        <v-divider></v-divider>
        <v-toolbar dense flat outlined color="blur">Permissions</v-toolbar>
        <v-sheet>
          <v-list-item class="v-sheet--outlined" dense v-for="permission in selected_item_permissions" :key="permission.id">
            <v-list-item-action>{{ permission.role }}</v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ permission.displayName }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ permission.emailAddress }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action></v-list-item-action>
          </v-list-item>
        </v-sheet>
        <v-card-actions class="justify-space-between">
          <v-btn color="error" @click="deleteSelectedItem">Delete</v-btn>
          <v-btn color="primary" @click="updateSelectedItem">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="create_item_dialog" @click:outside="toggleCreateItemDialog" max-width="500px">
      <v-card>
        <v-card v-if="create_item">
          <v-toolbar flat outlined dark color="primary">
            Create new material
            <v-spacer/>
            <v-btn icon @click="toggleCreateItemDialog"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text >
            <v-text-field label="Title" v-model="create_item.title" outlined></v-text-field>

            <v-select v-model="create_item.mimetype" :items="mimetypes" outlined></v-select>

            <v-switch label="Student can view" v-model="create_item.student_can_view"></v-switch>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="toggleCreateItemDialog">Cancel</v-btn>
            <v-btn color="primary" @click="createMaterial">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    materials: [],
    upload_item_dialog: false,
    create_item: null,
    create_item_dialog: false,
    selected_item: null,
    selected_item_dialog: false,
    selected_item_permissions: [],
    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],

    api_errors: []
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
  },
  created() {
    this.loadMaterials()
  },
  methods: {
    loadMaterials() {
      this.axios.get(`api/mocks/${this.$route.params.mock_id}/materials`)
          .then(({data}) => {this.materials = data.data})
    },
    materialIcon(material) {
      if(material.google_mimetype) {
        let mimetype = this.mimetypes.find(item => item.value === material.google_mimetype)
        if(mimetype) return mimetype.icon
      }
      return null
    },
    toggleCreateItemDialog() {
      if(!this.create_item_dialog) {
        this.create_item = {
          title: '',
          mimetype: 'application/vnd.google-apps.document',
          student_can_view: false,
        }
        this.create_item_dialog = true
      }
      else {
        this.create_item_dialog = false
        this.create_item = null
      }
    },
    createMaterial() {
      this.app_loading = true
      this.api_errors = []
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/materials`, this.create_item)
        .then(({data}) => {
          this.materials.push(data.data)
          this.toggleCreateItemDialog()
        })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true

      this.axios.get(`api/mocks/${this.$route.params.mock_id}/materials/${this.selected_item.id}/permissions`)
        .then(({data})=> {
          this.selected_item_permissions = data.data
        })

    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
      this.selected_item_permissions = []
    },
    updateSelectedItem() {
      this.app_loading = true
      this.api_errors = []
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/materials/${this.selected_item.id}`, this.selected_item)
        .then(({data}) => {
          console.log(data.data)
          this.closeSelectedItemDialog()
        })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    },
    deleteSelectedItem() {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}/materials/${this.selected_item.id}`, this.selected_item)
        .then(() => {
          this.closeSelectedItemDialog()
          this.loadMaterials()
        })
    },
  }
}
</script>
